import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const StyledPlacementOffer = styled.div`
  display: grid;
  border-radius: 1rem;
  background-color: #fff;
  padding: 1rem;
  gap: 3rem;

  ${breakpoint("tablet")`
    padding: 46px 63px;
  `}
`

export const Img = styled.img`
  height: 100px;

  ${breakpoint("tablet")`
    height: 150px;
  `}
`
